import { Component, OnDestroy } from '@angular/core';
import { XeroService } from '../shared/services/xero.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RouterLink } from '@angular/router';
import { MatAnchor } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'reports',
    templateUrl: './reports.component.html',
    providers: [XeroService],
    standalone: true,
    imports: [MatCard, MatCardContent, MatAnchor, RouterLink]
})
export class ReportsComponent implements OnDestroy {
  private ngUnsubscribe = new Subject<void>();
  showXeroReport = false;

  constructor(private xeroService: XeroService) {
    this.xeroService
      .getXeroStatus()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((status: any) => {
        this.showXeroReport = status.connected;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
